import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewCMSPageNew from "../../components/CMS/ViewCMSPageNew";



const ViewCMSPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="CMS" link2="/cms" title="View CMS" />

        {/* AddUserLayer */}
        <ViewCMSPageNew />


      </MasterLayout>
    </>
  );
};

export default ViewCMSPage;
